import { createStyles } from '../../../../../styles/helpers'

export default createStyles({
  controlsPanel: {
    textAlign: 'center',
    marginBottom: 40
  }
})
